import { apiSlice } from "../../../../app/apiSlice";

const apiSliceWithTags = apiSlice.enhanceEndpoints({
  addTagTypes: ["Session", "SessionTransfer"],
});

export const sessionApiSlice = apiSliceWithTags.injectEndpoints({
  endpoints: (builder) => ({
    getSession: builder.query({
      query: (parameter) => `/session/${parameter}`,
      providesTags: ["Session"],
    }),
    getSessionsPaginated: builder.query({
      query: ({ page = 1, per_page = 5, q = "" } = {}) => ({
        url: `/session/all`,
        params: { page, per_page, ...(q ? { q } : {}) },
      }),
      providesTags: ["Session"],
    }),
    getCurrentTerm: builder.query({
      query: () => `session/term/current`,
      providesTags: ["Session"],
    }),
    createSession: builder.mutation({
      query: (values) => ({
        url: "/session/create",
        method: "POST",
        body: { ...values },
      }),
      invalidatesTags: ["Session"],
    }),
    updateSession: builder.mutation({
      query: (values) => ({
        url: "/session/update",
        method: "PUT",
        body: { ...values },
      }),
      invalidatesTags: ["Session"],
    }),
    createTerm: builder.mutation({
      query: (values) => ({
        url: "/session/term/create",
        method: "POST",
        body: { ...values },
      }),
      invalidatesTags: ["Session"],
    }),
    updateTerm: builder.mutation({
      query: (values) => ({
        url: "/session/term/update",
        method: "PUT",
        body: { ...values },
      }),
      invalidatesTags: ["Session"],
    }),
    setSessionOverride: builder.mutation({
      query: ({ session_id }) => ({
        url: "/session/override",
        method: "POST",
        body: { session_id },
      }),
      invalidatesTags: ["Session"],
    }),
    clearSessionOverride: builder.mutation({
      query: () => ({ url: "/session/override", method: "DELETE" }),
      invalidatesTags: ["Session"],
    }),
    setTermOverride: builder.mutation({
      query: ({ term_id }) => ({
        url: "/session/term/override",
        method: "POST",
        body: { term_id },
      }),
      invalidatesTags: ["Session"],
    }),
    clearTermOverride: builder.mutation({
      query: () => ({ url: "/session/term/override", method: "DELETE" }),
      invalidatesTags: ["Session"],
    }),
    // ── Session Transfer ──────────────────────────────────────────────────
    startSessionTransfer: builder.mutation({
      query: (values) => ({
        url: "/session/transfer/start",
        method: "POST",
        body: { ...values },
      }),
      invalidatesTags: ["SessionTransfer"],
    }),
    getTransferStatus: builder.query({
      query: (taskId) => `/session/transfer/status/${taskId}`,
      keepUnusedDataFor: 0,
    }),
    cancelTransfer: builder.mutation({
      query: (taskId) => ({
        url: `/session/transfer/cancel/${taskId}`,
        method: "POST",
      }),
      invalidatesTags: ["SessionTransfer"],
    }),
    getTransferHistory: builder.query({
      query: ({ page = 1, per_page = 10 } = {}) => ({
        url: "/session/transfer/history",
        params: { page, per_page },
      }),
      providesTags: ["SessionTransfer"],
    }),
  }),
});

export const {
  useCreateSessionMutation,
  useGetSessionQuery,
  useGetSessionsPaginatedQuery,
  useGetCurrentTermQuery,
  useCreateTermMutation,
  useUpdateTermMutation,
  useUpdateSessionMutation,
  useSetSessionOverrideMutation,
  useClearSessionOverrideMutation,
  useSetTermOverrideMutation,
  useClearTermOverrideMutation,
  useStartSessionTransferMutation,
  useGetTransferStatusQuery,
  useCancelTransferMutation,
  useGetTransferHistoryQuery,
} = sessionApiSlice;
